export const LOGIN = '/login';
export const FORGOTPASSWORD = '/forgot-password';
export const RESETPASSWORD = '/reset-password';
export const DASHBOARD = '/dashboard';
export const CREATEIDEA = '/create-idea';
export const IDEALIST = '/idea-list';
export const MYIDEAS = '/my-ideas'
export const IDEADETAILS = "/idea-detail"